import { Eye, EyeSlash, Info } from "@phosphor-icons/react";
import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { RegisterSuccessProvider } from "../context/RegisterSuccessful";

export default function SignUpForm() {
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [userName, setUserName] = useState();
  const [fullName, setFullName] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [phoneNumber, setPhoneNumber] = useState();
  const [exchangeApiKey, setExchangeApiKey] = useState();
  const [exchangeApiSecret, setExchangeApiSecret] = useState();
  const [telegramApiId, setTelegramApiId] = useState();
  const [telegramApiHash, setTelegramApiHash] = useState();
  const [signalGiversUsernames, setSignalGiversUsernames] = useState();
  // const [signalGroup, setSignalGroup] = useState();
  const [leverage, setLeverage] = useState();
  const [nextForm, setNextForm] = useState(false);
  const [terms, setTerms] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const { setsuccessMessage } = useContext(RegisterSuccessProvider);
  const navigate = useNavigate();
  function submitForm(e) {
    e.preventDefault();
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      username: userName,
      fullName,
      email,
      password,
      confirmPassword,
      phoneNumber,
      exchangeApiKey,
      exchangeApiSecret,
      telegramApiId: telegramApiId * 1,
      telegramApiHash,
      signalGiversUsernames,
      signalGroup: "",
      leverage,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch("http://localhost:4000/api/register", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        console.log(result);
        setsuccessMessage(result);
      })
      .catch((error) => console.error(error));
      navigate("/auth/otp");
  }
  function Next(e) {
    e.preventDefault();
    setNextForm((curr) => !curr);
  }

  return (
    <div className="">
      <h1 className="text-center font-bold text-2xl text-white">SignUp</h1>
      <form className={nextForm ? "hidden" : "w-full flex flex-col gap-4 mt-4"}>
        <span className="flex flex-col gap-2">
          <label htmlFor="name" className="text-white">
            Username
          </label>
          <input
            type="text"
            name="name"
            placeholder="userName"
            id="userName"
            className="lg:w-[534px] lg:h-[56px] rounded-[12px] p-4 px-6"
            value={userName}
            onChange={(e) => setUserName(e.target.value)}
          />
        </span>
        <span className="flex flex-col gap-2">
          <label htmlFor="name" className="text-white">
            fullName
          </label>
          <input
            type="text"
            name="name"
            placeholder="fullName"
            id="fullName"
            className="lg:w-[534px] lg:h-[56px] rounded-[12px] p-4 px-6"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
          />
        </span>
        <span className="flex flex-col gap-2">
          <label htmlFor="Fullname" className="text-white">
            Email
          </label>
          <input
            type="email"
            name="Email"
            placeholder="Email"
            id="Email"
            className="lg:w-[534px] lg:h-[56px] rounded-[12px] p-4 px-6"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </span>
        <span className="flex flex-col gap-2">
          <label htmlFor="password" className="text-white">
            Password
          </label>
          <span className="relative w-full">
            <input
              type={showPassword ? "text" : "password"}
              name="passewd"
              placeholder="enter your password"
              id="password"
              className="lg:w-[534px] w-full lg:h-[56px] rounded-[12px] p-4 px-6"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            {showPassword ? (
              <EyeSlash
                size={32}
                className="cursor-pointer absolute top-2 right-5"
                color="black"
                onClick={() => setShowPassword((curr) => !curr)}
              />
            ) : (
              <Eye
                size={32}
                className="cursor-pointer absolute top-2 right-5"
                color="black"
                onClick={() => setShowPassword((curr) => !curr)}
              />
            )}
          </span>
        </span>
        <span className="flex flex-col gap-2">
          <label htmlFor="confirmPassword" className="text-white">
            confirm Password
          </label>

          <span className="relative w-full">
            <input
              type={showPassword1 ? "text" : "password"}
              name="confirmPassword"
              placeholder="enter your password"
              id="confirmPassword"
              className="lg:w-[534px] w-full lg:h-[56px] rounded-[12px] p-4 px-6"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            {showPassword1 ? (
              <EyeSlash
                size={32}
                className="cursor-pointer absolute top-2 right-5"
                color="black"
                onClick={() => setShowPassword1((curr) => !curr)}
              />
            ) : (
              <Eye
                size={32}
                className="cursor-pointer absolute top-2 right-5"
                color="black"
                onClick={() => setShowPassword1((curr) => !curr)}
              />
            )}
          </span>
        </span>
        <span className="flex flex-col gap-2">
          <label htmlFor="phone" className="text-white">
            Phone
          </label>
          <span className="flex w-full flex-col">
            <div className="relative flex items-center">
              <input
                type="text"
                name="phone"
                placeholder="phone"
                id="phone"
                className="lg:w-[534px] lg:h-[56px] rounded-[12px] p-4 px-6 w-full"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
              />
              <div className="group">
                <Info
                  size={32}
                  className="absolute top-2 right-4 cursor-pointer"
                />
                <div className="absolute right-0 top-8 bg-white p-2 w-[200px] hidden group-hover:block">
                  <p className="text-sm">
                    Note: the number that should be added is an active number on
                    WhatsApp or Telegram.
                  </p>
                </div>
              </div>
            </div>
          </span>
        </span>
        <div className="flex lg:flex-row justify-between text-white items-center flex-col">
          <button
            className="mt-9 lg:w-[120px] lg:h-[64px] rounded-full bg-[#01FF00] text-black px-6 py-3 font-bold text-xl"
            onClick={Next}
          >
            Next
          </button>
          <p className="mt-6">
            Already have anccount? <Link to="/auth/login">Log in</Link>
          </p>
        </div>
      </form>
      <form
        action=""
        className={nextForm ? "w-full flex flex-col gap-4 mt-4" : "hidden"}
      >
        <span className="flex flex-col gap-2">
          <label htmlFor="Exchange Api Key" className="text-white">
            Exchange Api Key
          </label>
          <input
            type="text"
            name="Exchange Api Key"
            placeholder="Exchange Api Key"
            id="Fullname"
            className="lg:w-[534px] lg:h-[56px] rounded-[12px] p-4 px-6"
            value={exchangeApiKey}
            onChange={(e) => setExchangeApiKey(e.target.value)}
          />
        </span>
        <span className="flex flex-col gap-2">
          <label htmlFor="Exchange Api Secret" className="text-white">
            Exchange Api Secret
          </label>
          <input
            type="text"
            name="Exchange Api Secret"
            placeholder="Exchange Api Secret"
            className="lg:w-[534px] lg:h-[56px] rounded-[12px] p-4 px-6"
            value={exchangeApiSecret}
            onChange={(e) => setExchangeApiSecret(e.target.value)}
          />
        </span>
        <span className="flex flex-col gap-2">
          <label htmlFor="telegramApiId" className="text-white">
            Telegram Api Id
          </label>

          <input
            type="text"
            name="telegramApiId"
            placeholder="telegram Api Id"
            className="lg:w-[534px] w-full lg:h-[56px] rounded-[12px] p-4 px-6"
            value={telegramApiId}
            onChange={(e) => setTelegramApiId(e.target.value)}
          />
        </span>
        <span className="flex flex-col gap-2">
          <label htmlFor="telegramApiHash" className="text-white">
            Telegram Api Hash
          </label>
          <span className="relative w-full">
            <input
              type="text"
              name="telegramApiHash"
              placeholder="Telegram Api Hash"
              className="lg:w-[534px] w-full lg:h-[56px] rounded-[12px] p-4 px-6"
              value={telegramApiHash}
              onChange={(e) => setTelegramApiHash(e.target.value)}
            />
          </span>
        </span>
        <span className="flex flex-col gap-2">
          <label htmlFor="signalGiversUsernames" className="text-white">
            signal Giver Username
          </label>
          <span className="flex w-full flex-col">
            <div className="relative flex items-center">
              <input
                type="text"
                name="signalGiversUsernames"
                placeholder="signal Givers Username"
                className="lg:w-[534px] lg:h-[56px] rounded-[12px] p-4 px-6 w-full"
                value={signalGiversUsernames}
                onChange={(e) => setSignalGiversUsernames(e.target.value)}
              />

              <div className="absolute right-0 top-8 bg-white p-2 w-[200px] hidden ">
                <p className="text-sm">
                  Note: the number that should be added is an active number on
                  WhatsApp or Telegram.
                </p>
              </div>
            </div>
          </span>
        </span>
        <span className="flex flex-col gap-2">
          <label htmlFor="leverage" className="text-white">
            leverage
          </label>
          <span className="flex w-full flex-col">
            <div className="relative flex items-center">
              <input
                type="number"
                name="leverage"
                placeholder="leverage"
                className="lg:w-[534px] lg:h-[56px] rounded-[12px] p-4 px-6 w-full"
                value={leverage}
                onChange={(e) => setLeverage(e.target.value)}
              />
            </div>
          </span>
        </span>
        <span className="flex gap-2 text-white">
          <input
            type="checkbox"
            name="terms"
            id=""
            checked={terms}
            onClick={(e) => setTerms(e.target.checked)}
          />
          <p>
            By creating an account, I agree to our{" "}
            <Link className="text-blue-300">Terms of use</Link> and{" "}
            <Link className="text-blue-300">Privacy Policy</Link>
          </p>
        </span>
        <div className="flex justify-between text-white items-center">
          <button
            className="mt-9  lg:w-fit lg:h-[64px] rounded-full bg-[#01FF00] text-black px-6 py-3 font-bold text-xl"
            onClick={submitForm}
          >
            Sign Up
          </button>
          <p>
            Already have anccount? <Link to="/auth/login">Log in</Link>
          </p>
        </div>
      </form>
    </div>
  );
}
